// Ported from LC2's CampaignPerformance.js (commons/components/HomeTabs/Performance/) —
// same lazy `getCampaignById` fetch (kept for parity/side-effects, same as LC2) plus the
// concession comps metric. LC2 also had a commented-out `<RenewalPerformance />` for
// `campaign?.subtype == 'Renewals'` — that component doesn't exist anywhere in LC2's tree
// (dead/aspirational code), so there's nothing to port for it.
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Stack} from '@mui/material';

import {getDashboardCampaign} from '../../../app/store/reducers/dashboard';
import {useLazyGetCampaignByIdQuery} from '../../../features/actionsApi/campaignsSlice';
import ConcessionComps from './ConcessionComps';

const CampaignPerformance = () => {
    const dashboardCampaign = useSelector(getDashboardCampaign);
    const [fetchCampaign] = useLazyGetCampaignByIdQuery();

    useEffect(() => {
        if (dashboardCampaign?.sfid) {
            fetchCampaign(dashboardCampaign.sfid);
        }
    }, [dashboardCampaign, fetchCampaign]);

    return (
        <Stack direction="column" rowGap={2} sx={{width: '100%'}}>
            <ConcessionComps />
        </Stack>
    );
};

export default CampaignPerformance;
